
import { ImageData } from "./types";
import { supabase } from "@/integrations/supabase/client";

export const getImageUrl = (image: ImageData) => {
  if (image?.storage_path) {
    const { data } = supabase.storage
      .from('images')
      .getPublicUrl(image.storage_path);
    return data.publicUrl;
  }
  return null;
};

export const galleryData = [
  {
    title: "Leidenschaften",
    description: "Ob Tiefschnee oder Piste - Hauptsache in den Bergen!",
    uploadSection: "passions-activities",
    sectionTitle: "NS6b 1 - Leidenschaften",
    fallbackImages: [
      "https://images.unsplash.com/photo-1551524559-8af4e6624178",
      "https://images.unsplash.com/photo-1483921020237-2ff51e8e4b22",
      "https://images.unsplash.com/photo-1610995195985-7229a1409d83",
    ]
  },
  {
    title: "Lieblingslieder",
    description: "Musik verbindet Menschen und berührt Herzen",
    uploadSection: "passions-songs",
    sectionTitle: "NS6b 3 - Lieder",
    isVideoGallery: true,
    videos: [
      {
        title: "TOCCATA UND FUGE IN D MINOR - JS BACH",
        url: "https://www.youtube.com/embed/ho9rZjlsyYY"
      },
      {
        title: "THE UNFORGIVEN II - METALLICA",
        url: "https://www.youtube.com/embed/5bt7kAVxKfs"
      },
      {
        title: "BOHEMIAN RHAPSODY - QUEEN",
        url: "https://www.youtube.com/embed/fJ9rUzIMcZQ"
      },
      {
        title: "HOTEL CALIFORNIA - THE EAGLES",
        url: "https://www.youtube.com/embed/Br3KkvgMAZY"
      },
      {
        title: "DER MESSIAS: HALLELUJA - G.F. HÄNDEL",
        url: "https://www.youtube.com/embed/usfiAsWR4qU"
      },
      {
        title: "STAIRWAY TO HEAVEN - LED ZEPPELIN",
        url: "https://www.youtube.com/embed/X791IzOwt3Q"
      },
      {
        title: "NOTHING ELSE MATTERS - METALLICA",
        url: "https://www.youtube.com/embed/tAGnKpE4NCI"
      },
      {
        title: "NOVEMBER RAIN - GUNS N' ROSES",
        url: "https://www.youtube.com/embed/8SbUC-UaAxE"
      }
    ],
    fallbackImages: []
  }
];
